import { render, staticRenderFns } from "./commodityList.vue?vue&type=template&id=67f954fe&scoped=true"
import script from "./commodityList.vue?vue&type=script&lang=js"
export * from "./commodityList.vue?vue&type=script&lang=js"
import style0 from "./commodityList.vue?vue&type=style&index=0&id=67f954fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f954fe",
  null
  
)

export default component.exports